import React from 'react';
import UserAvatar from 'react-user-avatar';

/**
* @desc Candidate Initials in candidate profile section
* @param props
* @return Candidate Initials 
*/
const Initials = (props) => {
  const initialColor=['#E0E9F2', '#C9EDE6', '#C4CAD0', '#F4ADAE', '#E9D7D8', '#EAC0CE'];

	return ( <UserAvatar className="UserAvatar-light" name={props.initials?props.initials:'--'} colors={initialColor}/> );
}

const Photo = (props) => {
return ( <img src={props.candidatePhoto} /> );
}

function Profile(props) {
  if (props.candidatePhoto) {
    return <Photo candidatePhoto={props.candidatePhoto} />;
  }
  return <Initials initials={props.initials} />
}

/**
* @desc CandidatePhoto in candidate profile section
* @param props
* @return CandidatePhoto
*/
const CandidatePhoto = (props) => {
  return (
    <div className="Candidate-Photo-Container">
      <Profile initials={props.initials} candidatePhoto={props.candidatePhoto} />      
      <div class="rec-image-upload-overlay">
        <div class="text">Upload</div>
      </div> 
    </div>
  );
}

export default CandidatePhoto;


// WEBPACK FOOTER //
// ./src/components/CandidatePhoto/CandidatePhoto.js